/// <reference path="./global.d.ts" />
/*!
 * @preserve
 * PingClient.js
 * PingClient Frontend JS for dein-ip-check.de
 *
 * @version 3.0
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

// Ping-Client Library laden
import "./lib/library";

// ChartJS + Streaming Modul ladenn
let Chart = require("chart.js");
require("chartjs-plugin-streaming");

// Validate IPv4/6
const isIp = require('is-ip');
const isDomain = require('is-valid-domain');

window.onload = () => {
    // Moment-Framework laden zur Formatierung von Zahlen
    let moment = require("moment");
    require("moment/locale/de");

    if (PINGLANGUAGE == "EN") {
        moment.locale("en");
    } else {
        moment.locale("de");
    }

    //
    // benötigte Variablen instanzieren
    //

    let domPingStart = $("#pingStart");
    let domPingStop = $("#pingStop");
    
    // Setze Proparty-Name für die "Tab Inaktiv"-Erkennung der einzelnen Browser
    let hidden: string,
        visabilityMode: string,
        updateTimer: number,
        websocket: WebSocket,
        dataPing: PingCheckResult[];

    // Chart-Konfiguration
    let chartConfiguration = {
        responsive: true,
        legend: {display: true},
        scales: {
            xAxes: [{
                type: "realtime",
                time: {
                    minUnit: "second",
                    displayFormats: {
                        second: moment.localeData().longDateFormat("LTS"),
                        minute: moment.localeData().longDateFormat("LT")
                    },
                    tooltipFormat: `${moment.localeData().longDateFormat("L")}  ${moment.localeData().longDateFormat("LTS")}`
                }
            }],
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    callback: function (value: any) {
                        return `${value.toFixed(1).toString()}ms`;
                    }
                },
                scaleLabel: {
                    display: true,
                    labelString: `${PINGSTRINGS["Paketlaufzeit"]} (ms)`
                }
            }]
        },
        tooltips: {
            callbacks: {
                label: function (tooltipItems: any, data: any) {
                    return `${data.datasets[tooltipItems.datasetIndex].label}: ${tooltipItems.yLabel} ms`;
                }
            }

        },
        plugins: {
            streaming: {
                ttl: 600000,        // 10 Minuten * 60 Sekunden * 1000 (ms)
                delay: 2000,        // 2 Sekunden verzögert darstellen * 1000 (ms)
                pause: true         // Scrollen vom Start an aktiviert
            }
        }
    };

    // Leeres Chart-Data Array
    let data = {
        labels: <number[]>[],
        datasets: [
            {
                label: [PINGSTRINGS["Paketlaufzeit"]],
                backgroundColor: "rgba(60, 197, 209, 0.5)",
                borderColor: "rgba(60, 197, 209, 1)",
                pointColor: "rgba(151,187,205,1)",
                pointStrokeColor: "#fff",
                data: <number[]>[],
            },
            {
                label: ["Jitter"],
                backgroundColor: "rgba(242, 190, 123, 0)",
                borderColor: "rgba(242, 190, 123, 1)",
                pointColor: "rgba(242, 190, 123,1)",
                pointStrokeColor: "#fff",
                borderDash: [10, 5],
                data: <number[]>[],
            }
        ]
    };

    // Chart anlegen
    let chartCanvas = <HTMLCanvasElement>document.getElementById("pingChart");
    let ctx = chartCanvas.getContext('2d');
    ctx.canvas.width = $("#pingCHart").innerWidth();
    ctx.canvas.height = 400;

    let pingChart = new Chart(ctx, {
            type: "line",
            data: data,
            options: chartConfiguration
        }
    );

    // HTML Elemente
    let chartMesstationlHTMLElement = $("#messureServer");
    let chartLaufzeitHTMLElement = $("#chartLaufzeit");
    let chartipprotokollHTMLElement = $("#ipprotokoll");

    /*
     * Callback-Funktionen für das gesamte Document
     */

    // Ermitteln ob Das Tab das Focus verloren hat
    if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
        hidden = "hidden";
        visabilityMode = "visibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
        hidden = "msHidden";
        visabilityMode = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
        hidden = "webkitHidden";
        visabilityMode = "webkitvisibilitychange";
    }
    if (typeof document.addEventListener !== "undefined" && typeof document.hiddenMode !== "undefined") {
        document.addEventListener(visabilityMode, callBackVisibilityChanged, false);
    }

    function callBackVisibilityChanged(): void {
        if (hidden) domPingStop.trigger("click");
    }

    // Call-Back Funktion: Aktualisiere Chart bei Änderung der Laufzeit (während keine automatisches Updaten erfolgt)
    function callBackLaufzeitChanged(event: JQuery.Event): void {
        event.preventDefault();

        // Aktualisiere Chart, während Websocket-Verbindung offline ist
        pingChart.options.plugins.streaming.duration = parseInt(chartLaufzeitHTMLElement.val() as string) * 1000;
        pingChart.update({duration: 0});

        // Chart weiterhin pauseren?
        pingChart.options.plugins.streaming.pause = domPingStart.hasClass("active");
    }
    
    // Call-Back Funktion: Reagiere auf Protokoll-Änderung durch den Nutzer
    function callBackProtokollChanged(event: JQuery.Event): void {
        event.preventDefault();
        
        if (!domPingStart.hasClass("active")) {
            domPingStop.trigger("click");
            setTimeout(function () {
                domPingStart.trigger("click");
            }, 500);                // 2 Sekunden TImeout
        }
    }
    
    // AUf Änderungen im Formular reagieren
    chartLaufzeitHTMLElement.on("change", callBackLaufzeitChanged);
    chartipprotokollHTMLElement.on("change", callBackProtokollChanged);
    chartMesstationlHTMLElement.on( "change", callBackProtokollChanged);

    /**
     * PING-Vorgang starten
     */
    domPingStart.on("click", function (event: JQuery.Event) {
        // Prevent Default Action / detect disabeld Button
        event.preventDefault();
        
        // Abbruch falls Start-Button nicht freigegeben ist
        if(domPingStart.hasClass('disabled')) return;

        // Zähler
        let numPing: number = 0;
        let numTimeout: number = 0;

        // Data-Sets zurücksetzen
        data.labels = [];
        data.datasets[0].data = [];
        data.datasets[0].data = [];
        dataPing = [];

        // Start-Button sperren / Stop-Button entsperren
        domPingStart.removeClass("active").addClass("disabled");
        domPingStop.removeClass("disabled").addClass("active");

        // Chart starten
        pingChart.options.plugins.streaming.duration = parseInt(chartLaufzeitHTMLElement.val() as string) * 1000;
        pingChart.options.plugins.streaming.pause = false;
        pingChart.update({duration: 0});

        // Websocket abhängig vom gewählten Ziel starten 
        let messtation: string;
        if (chartMesstationlHTMLElement.val() == "dus") {
            messtation = "wss://de-dus.ping.dein-ip-check.de/api/";
        } else if (chartMesstationlHTMLElement.val() == "nue") {
            messtation = "wss://de-nue.ping.dein-ip-check.de/api/";
        } else if (chartMesstationlHTMLElement.val() == "brl") {
            messtation = "wss://de-brl.ping.dein-ip-check.de/api/";
        } else if (chartMesstationlHTMLElement.val() == "ffm") {
            messtation = "wss://de-ffm.ping.dein-ip-check.de/api/";
        } else {
            displayErrorMessage(PINGSTRINGS["Fehler mit der Verbindung zur Messstation"] + "- 2");
            return;
        }
        
        // Prüfe IP ADresse
        let clientIP = $("#ipadresse").val();
        let clientProtocol = $("#ipprotokoll").val();
        
        if(!isDomain(clientIP)) {
            if (!isIp(clientIP)) {
                displayErrorMessage(PINGSTRINGS["Ungültige IPv4/IPv6-Adresse oder Hostname angegeben"]);
                return;
            }

            // Protokoll ermitteln
            if (clientProtocol !== "4" && clientProtocol !== "6") {
                displayErrorMessage(PINGSTRINGS["Ungültiges Protokoll angegeben"]);
                return;
            }

            // Prüfe auf richtiges Protokoll bei einer IP-Adresse
            if (isIp.v6(clientIP) && clientProtocol !== '6') {
                displayErrorMessage(PINGSTRINGS["Ungültiges Protokoll angegeben"] + " - IPv4 " + PINGSTRINGS["anstatt"] + " IPv6");
                return;
            } else if (isIp.v4(clientIP) && clientProtocol !== '4') {
                displayErrorMessage(PINGSTRINGS["Ungültiges Protokoll angegeben"] + " - IPv6 " + PINGSTRINGS["anstatt"] + " IPv4");
                return;
            }
        }
                
        // Websocket-Verbindung aufbauen
        websocket = new WebSocket(messtation);

        // Callback-Funktion: Websocket Verbindung aufgebaut
        websocket.onopen = function () {
            // Ping-Request absetzen
            updateTimer = window.setInterval(
                function () {
                    let command = `ping|${clientIP}|${clientProtocol}|de`;
                    console.log(command);
                    websocket.send(command);
                }, 1000
            )
        };

        // Callback Funktion: Websocket schließt
        websocket.onclose = function () {
            // Intervall stoppen
            window.clearInterval(updateTimer);
        };

        // Callback: Websocket Fehler
        websocket.onerror = function () {
            displayErrorMessage(`${PINGSTRINGS["Fehler mit der Verbindung zur Messstation"]} (${websocket.readyState})`);
        };

        // Callback Funktion: Websocket erhält eine Nachricht
        websocket.onmessage = function (evt: MessageEvent) {
            // Antwort parsen
            let response: PingCheckWebsocketResponse = JSON.parse(evt.data);

            // Antwort auswerten
            if (response.status == "ok") {
                // PaketlaufzeitBackground öffnen
                $("#paketlaufzeit").show();
                $("#paketlaufzeitError").hide();

                // Informationen zu den Messdaten aktualisieren
                $("#paketlaufzeitClientIP").html(response.clientip);
                $("#paketlaufzeitMesstation").html(
                    $("#chartProtokoll option[value=" + $("#chartProtokoll").val() + "]").text()
                );

                // Ergebnis abrufen
                let zeitstempel: number = new Date().setMilliseconds(0);
                let laufzeit: number = parseInt(response.message);
                numPing++;

                if (laufzeit <= -2) {
                    // Harter Fehler - beende Socket-Verbindung
                    displayErrorMessage(PINGSTRINGS["ICMP Ping ist fehlgeschlagen"]);
                    return;
                } else if (laufzeit == -1) {
                    // Timeout
                    numTimeout++;
                    $("#paketlaufzeitRtt")
                        .html("<span style='font-weight: bold; color: rgb(255,76,76)'><i class='fa fa-exclamation-triangle'></i> Timeout</span>")
                        .addClass("animated pulse infinite");
                    return;
                }

                // Jitter berechnen
                let jitter: number;
                if (data["datasets"][0]["data"].length > 0) {
                    jitter = Math.abs(laufzeit - data["datasets"][0]["data"].last());
                } else {
                    jitter = 0;
                }

                // Jitter speichern und Array aufräumen
                dataPing.push({
                    zeitstempel: zeitstempel,
                    jitter: jitter,
                    ping: laufzeit
                });

                // Jitter-Durchschnitt der letzten 60 Sekunden erzeugen
                dataPing.reduceRight(
                    function (acc: object, item: PingCheckResult, index: number, object: PingCheckResult[]): object {
                        if (moment(item.zeitstempel).add(1, "minutes").isBefore(/*now*/)) {
                            object.splice(index, 1);
                        }
                        return object;
                    }, []
                );

                // Daten hinzufügen und die letzten x Elemente an ChartJS übergeben
                data["datasets"][0]["data"].push(laufzeit);
                data["labels"].push(zeitstempel);
                data["datasets"][1]["data"].push(Math.round(dataPing.objAvg("jitter")));

                // Debug-Ausgabe der Chart-Daten
                //console.log( lastValue + " - "  + laufzeit + " = " + jitter  );
                //console.log( chartLaufzeit );
                //console.log( data["datasets"][0]["data"] );
                //console.log( data["labels"] );

                // Chart erzeugen
                createChartStatistik();
                pingChart.data = data;
                pingChart.update();
            } else {
                // Fehler zurückgemeldet
                console.error(`${response.status}: ${response.message}`);
                displayErrorMessage(PINGSTRINGS["ICMP Ping ist fehlgeschlagen"]);
            }
        };

        // Erzeuge Chart-Statistik
        function createChartStatistik() {
            // Paketverlust berechnen
            let laufzeit = data["datasets"][0]["data"].last();

            // Farbe ermitteln
            let strLaufzeit = `${laufzeit.toString()} ms`;
            let color: string;
            if (isNaN(laufzeit)) {
                color = "119, 0, 0";
                strLaufzeit = "Timeout"
            } else if (laufzeit <= 40) {
                color = "0, 119, 0";
            } else if (laufzeit <= 100) {
                color = "214, 153, 11";
            } else {
                color = "102, 102, 102";
            }

            // Paketverlust ermitteln
            let paketVerlust: number = Math.round(100 * numTimeout / numPing);
            let avgJitter: number = Math.round(dataPing.objAvg("jitter"));
            let avgPing: number = Math.round(dataPing.objAvg("ping"));

            // Ergebnis ausgeben
            $("#paketlaufzeitRtt")
                .html(`<span style='color: rgb(${color})'>${strLaufzeit}</span>`)
                .removeClass("animated pulse infinite");
            $("#paketlaufzeitLost").html(`${paketVerlust} %`);
            $("#paketlaufzeitJitter").html(`+${avgJitter} ms`);
            $("#paketlaufzeitAvgPing").html(`${avgPing} ms`);
        }

        // Error-Ausgabe
        function displayErrorMessage(errorMsg: string) {
            // Intervall stoppen
            clearInterval(updateTimer);
            pingChart.options.plugins.streaming.pause = true;

            // Loader-Spinner deaktivieren
            $("#pingChart").show();
            $("#paketlaufzeitBackground").show();
            $("#paketlaufzeit").hide();
            $("#paketlaufzeitError").show();

            // Protokoll
            $("#paketlaufzeitProtocol").html("IP Adresse");
            
            // Fehlermeldung ausgeben
            $("#paketlaufzeitError > div").text(errorMsg);

            // Setze Buttons zurück
            domPingStart.removeClass("disabled").addClass("active");
            domPingStop.removeClass("active").addClass("disabled");
        }
    });

    /**
     * PING-Vorgang beenden
     */
    domPingStop.on("click", function (event: JQuery.Event) {
        // Prevent Default Action / detect disabeld Button
        event.preventDefault();
        if ($(this).hasClass("disabled")) {
            return false;
        }

        // Fehlermeldung-Feld ausblenden
        $("#paketlaufzeit").show();
        $("#paketlaufzeitError").hide();

        // Intervall stoppen und Realtime-Chart pausieren
        clearInterval(updateTimer);
        pingChart.options.plugins.streaming.pause = true;
        pingChart.update({duration: 0});

        // Websocket-Verbindung beenden
        try {
            if (websocket.readyState !== websocket.CLOSED && websocket.readyState !== websocket.CLOSING) {
                websocket.close();
            }
        } catch (err) {
            console.warn("Fehler beim Verbindungsarbau");
        }

        // Setze Buttons zurück
        $("#pingStart").removeClass("disabled").addClass("active");
        $("#pingStop").removeClass("active").addClass("disabled");
    });
};
